import { Component, effect, inject, signal } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'full-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  public showLoader = signal<boolean>(false);
  private readonly _loaderService = inject(LoaderService);

  constructor() { 
    effect( () => {
      this.showLoader.set( this._loaderService.loaderStateSignal() );
    },{ allowSignalWrites: true });
  }

}
